<template>
  <div class="document">
    <WebClient_Document msg="Welcome to Web & Document System"/>
  </div>
</template>

<script>
// @ is an alias to /src
import WebClient_Document from '@/components/WebClient_Document.vue'

export default {
  name: 'Document',
  components: {
    WebClient_Document
  }
}
</script>
